<template>
	<div class="full">
		<div class="full" ref="aniamte3_stage"></div>
	</div>
</template>

<style scoped>

</style>
<script>
	import {
		gsap
	} from "gsap"
	import * as PIXI from 'pixi.js'
	
	export default {
		props: {
			status: {
				type: String,
				default: function() {
					return ''
				}
			}
		},
		data() {
			return {
				animate: []
			};
		},
		computed: {

		},
		created(){
			
		},
		mounted() {
			
			let loader = new PIXI.Loader()
				loader.add([
					{url:require('../img/animate1_bg.jpg'),crossOrigin: false},
					{url:require('../img/animate1_ele1.png'),crossOrigin: false},
					{url:require('../img/animate1_ele2.png'),crossOrigin: false},
					{url:require('../img/animate3_ele2.png'),crossOrigin: false},
					{url:require('../img/animate1_ele3.png'),crossOrigin: false},
					{url:require('../img/animate1_ele4.png'),crossOrigin: false},
		
				])	
				loader.load((loader)=>{
					this.Init(loader)	
					setTimeout(() => {
						this.begin()
					}, 500)
					
				})			
			
		},
		watch: {
			// status(val) {
			// 	if (val == 'success') {
			// 		setTimeout(() => {
			// 			this.begin()
			// 		}, 500)
			// 	}
			// }
		},
		methods: {
			begin() {
				this.animate.forEach((item) => {
					item.play()
				})
			},
			Init(loader) {			
				this.app = new PIXI.Application({
					width: 646,
					height: 1022,
					backgroundAlpha: 0,
					resolution: 1,
				})
				this.app.view.classList.add('full')
				this.$refs.aniamte3_stage.appendChild(this.app.view)
				let bg = new PIXI.Sprite(loader.resources[require('../img/animate1_bg.jpg')].texture)
				bg.width = 646
				bg.height = 1022
				this.app.stage.addChild(bg)



				let car = new PIXI.Sprite(loader.resources[require('../img/animate1_ele1.png')].texture)
				car.width = 248
				car.height = 177
				car.x = 397
				car.y = 886

				let car_animateHandle = gsap.timeline({
					onComplete: () => {
						this.$emit('next')
					}
				})
				car_animateHandle.pause()
				this.animate.push(car_animateHandle)

				car_animateHandle.to(car, {
					x: -20,
					y: 780,
					duration: 1,
					ease: 'none'
				})
				car_animateHandle.call(() => {
					car.width = 156
					car.height = 228
					car.x = 0
					car.y = 686
					car.texture = loader.resources[require('../img/animate1_ele2.png')].texture
				})
				car_animateHandle.to(car, {
					y: 506,
					duration: .5,
					ease: 'none'
				})
				car_animateHandle.call(() => {
					car.width = 248
					car.height = 180
					car.x = -10
					car.y = 467
					car.texture = loader.resources[require('../img/animate1_ele3.png')].texture
				})
				car_animateHandle.to(car, {
					x: 487,
					y: 186,
					duration: 1.2,
					ease: 'none'
				})
				car_animateHandle.call(() => {
					car.width = 156
					car.height = 228
					car.x = 608
					car.y = 88
					car.texture = loader.resources[require('../img/animate1_ele2.png')].texture
				})
				car_animateHandle.to(car, {
					x: 427,
					y: -250,
					duration: 1,
					ease: 'none'
				})
				car.animateHandle = car_animateHandle
				this.app.stage.addChild(car)

				let cloud = new PIXI.Sprite(loader.resources[require('../img/animate3_ele2.png')].texture)
				cloud.width = 1681
				cloud.height = 1117
				cloud.x = -250
				cloud.y = 800

				let cloud_animateHandle = gsap.timeline()
				cloud_animateHandle.pause()
				this.animate.push(cloud_animateHandle)

				cloud_animateHandle.to(cloud, {
					y: 100,
					duration: 4,
					ease: 'none'
				})
				cloud.animateHandle = cloud_animateHandle
				this.app.stage.addChild(cloud)

				let text = new PIXI.Sprite(loader.resources[require('../img/animate1_ele4.png')].texture)
				text.width = 167
				text.height = 124
				text.x = 280
				text.y = 4

				let text_animateHandle = gsap.timeline()
				text_animateHandle.pause()
				this.animate.push(text_animateHandle)

				text_animateHandle.to(text, {
					y: text.y + 10,
					duration: 1,
					ease: 'none',
					yoyo: true,
					repeat: -1
				})
				text.animateHandle = text_animateHandle
				this.app.stage.addChild(text)



			}
		},
		components: {

		}
	}
</script>
